import {
  aachho,
  aachhoIpad,
  aachhoMobile,
  aachhoScreen1,
  aachhoScreen2,
  adminty,
  aqari360,
  aqari360Ipad,
  aqari360Mobile,
  aqari360Screen1,
  aqari360Screen2,
  bluestone,
  bluestoneIpad,
  bluestoneMobile,
  bluestoneScreen1,
  bluestoneScreen2,
  bunaai,
  bunaaiIpad,
  bunaaiMobile,
  bunaaiScreen1,
  bunaaiScreen2,
  businessIgnite,
  businessIgniteIpad,
  businessIgniteMobile,
  businessIgniteScreen1,
  businessIgniteScreen2,
  debookFIG,
  debookFIGIpad,
  debookFIGMobile,
  debookFIGScreen1,
  debookFIGScreen2,
  debppkapp,
  debppkappIpad,
  debppkappMobile,
  debppkappScreen1,
  debppkappScreen2,
  diffrEvent,
  diffrEventIpad,
  diffrEventMobile,
  DinkPickleball,
  DinkPickleballIpad,
  DinkPickleballMobile,
  DinkPickleballScreen1,
  DinkPickleballScreen2,
  draft,
  draftIpad,
  draftMobile,
  draftScreen1,
  draftScreen2,
  dumbgood,
  dumbgoodIpad,
  dumbgoodMobile,
  dumbgoodScreen1,
  dumbgoodScreen2,
  feedly,
  feedlyIpad,
  feedlyMobile,
  feedlyScreen1,
  feedlyScreen2,
  imgur,
  imgurIpad,
  imgurMobile,
  imgurScreen1,
  imgurScreen2,
  Jawlah360,
  lucid,
  magicKey,
  magicKeyIpad,
  magicKeyMobile,
  milkgarage,
  milkgarageMobile,
  mjawlah360,
  najeeb,
  pickleballAdmin,
  pickleballAdminIpad,
  pickleballAdminMobile,
  pickleballAdminScreen1,
  pickleballAdminScreen2,
  pickleballMe,
  pickleballMeIpad,
  pickleballMeMobile,
  pickleballMeScreen1,
  pickleballMeScreen2,
  newsBulb,
  rejouice,
  rejouiceIpad,
  rejouiceMobile,
  rejouiceScreen1,
  rejouiceScreen2,
  songadhpathshala,
  souqalfajr,
  sundownStudio,
  sundownStudioIpad,
  sundownStudioMobile,
  sundownStudioScreen1,
  sundownStudioScreen2,
  tasheel,
  vihatech,
  vihatechIpad,
  vihatechMobile,
  vihatechScreen1,
  vihatechScreen2,
  yamahaeurope,
  yamahaeuropeIpad,
  yamahaeuropeMobile,
  yamahaeuropeScreen1,
  yamahaeuropeScreen2,
  newsBulbMobile,
  siddhivinayakGroup,
  siddhivinayakGroupMobile,
  siddhivinayakGroupIpad,
  siddhivinayakGroupScreen1,
  siddhivinayakGroupScreen2,
  tasheelMobile,
  tasheelScreen2,
  tasheelScreen1,
  tasheelIpad,
  souqalfajrMobile,
  souqalfajrScreen2,
  souqalfajrScreen1,
  souqalfajrIpad,
  najeebMobile,
  najeebScreen2,
  najeebScreen1,
  najeebIpad,
  admintyMobile,
  admintyScreen2,
  admintyScreen1,
  admintyIpad,
  lucidMobile,
  lucidScreen2,
  lucidScreen1,
  lucidIpad,
  songadhpathshalaMobile,
  songadhpathshalaIpad,
  songadhpathshalaScreen1,
  songadhpathshalaScreen2,
  openMd,
  openMdMobile,
  openMdIpad,
  openMdScreen1,
  openMdScreen2,
  thrivea,
  thriveaMobile,
  thriveaIpad,
  thriveaScreen1,
  thriveaScreen2,
} from "../assets/images";

// 📦 Project Data Type HOME
const projectsHomeData = [
  // Thrivea HR platform
  {
    name: "Thrivea",
    description:
      "THRIVEA is a fresh, innovative HR platform best suited for small and medium enterprises on a growth path. Their design team provided polished Figma designs, and my role was to bring those to life on the web with pixel-perfect precision, performance optimization, and responsive behavior.",
    slug: "thrivea-hr-platform",
    title: "Thrivea",
    category: "HR platform - SAAS",
    client: "Ivan Stantic",
    date: "11 Aug 2024",
    location: "USA",
    designer: "Provided by client",
    gridImages1: [thrivea, thriveaMobile],
    gridImages2: [thriveaIpad, thriveaScreen1, thriveaScreen2],

    overviewParagraph1:
      "For Thrivea, I was responsible for converting their detailed Figma designs into a fully functional, responsive web experience. The focus was on maintaining design accuracy while ensuring smooth performance across devices and browsers. Every screen was carefully implemented to match the intended brand identity and usability goals.",

    overviewChecks: [
      "Delivered pixel-perfect Figma to code conversion",
      "Built responsive layouts optimized for desktop, tablet, and mobile",
      "Used React / Next.js with modular, reusable components",
      "Applied Tailwind CSS for rapid styling and scalability",
      "Ensured accessibility standards and cross-browser consistency",
    ],

    overviewParagraph2:
      "The Thrivea platform emphasizes simplicity, employee-centric design, and scalable HR operations. My role was to make sure their product vision translated seamlessly into the web interface without compromising on performance or user experience.",

    overviewParagraph3:
      "This project involved close collaboration with the client to align design intent with technical feasibility. The end result was a polished, responsive platform that stayed true to the original Figma while being production-ready and scalable.",

    testingResultParagraphs: [
      "Conducted detailed QA testing to verify responsiveness across desktop, tablet, and mobile breakpoints.",
      "Validated animations, transitions, and component behaviors to ensure smooth and consistent user experience.",
      "Performed cross-browser checks (Chrome, Safari, Firefox, Edge) to ensure layout and functionality integrity.",
    ],

    tags: [
      {name: "Tailwind CSS", color: "blue-text-gradient"},
      {name: "HTML", color: "green-text-gradient"},
      {name: "JavaScript", color: "pink-text-gradient"},
      {name: "React / Next.js", color: "orange-text-gradient"},
    ],
    image: thrivea,
    websiteLink: "https://thrivea.devplace.fun/", // replace with actual Thrivea link if available
    isVideo: false,
  },
  // Draft inc. Japan
  {
    name: "Draft",
    description:
      "Draft is a design studio founded by Taiju Yamashita in 2008. With a focus on interior design, product design, and architectural design from urban development to branding.",
    slug: "draft-inc",
    title: "Draft inc. Japan",
    category: "Architecture & Interior",
    client: "Taiju Yamashita",
    date: "25 Sep 2024",
    location: "USA",
    designer: "-",
    gridImages1: [draft, draftMobile],
    gridImages2: [draftIpad, draftScreen1, draftScreen2],

    overviewParagraph1:
      "At DRAFT, I helped translate their design philosophy—'ALL HAPPY BY DESIGN'—into a visually rich and performance-optimized web experience. The site showcases their multidisciplinary approach across architecture, interiors, product design, and branding. Using animation frameworks and scoped styling, the focus was on mirroring their immersive, people-centric spaces through a responsive, modern interface.",

    overviewChecks: [
      "Built interactive layouts that echo real-world spatial design principles",
      "Used GSAP and Locomotive Scroll for immersive, scroll-based storytelling",
      "Translated brand values into modular HTML/CSS components",
      "Integrated graph/data views to support case studies and project showcases",
      "Ensured cross-platform accessibility and smooth user experience",
    ],

    overviewParagraph2:
      "DRAFT, under the philosophy of “ALL HAPPY BY DESIGN,” pursues unlocking the potential of space and shaping how people interact with environments, aiming to create designs that bring happiness through innovative architecture, interior, product, and branding solutions.",

    overviewParagraph3:
      "Founded in April 2008 by architect Taiju Yamashita, DRAFT began with office interiors and grew into large-scale spaces, furniture brands such as DAFT about DRAFT and urban development, with global studios and subsidiaries in the Philippines and Serbia.",

    testingResultParagraphs: [
      "The website underwent detailed QA testing including scroll behavior validation, GSAP animation consistency, and layout integrity across all major screen sizes and browsers.",
      "CSS/SCSS modules were validated for responsiveness, and Bootstrap components were tested to handle variable content blocks and multilingual expansion.",
      "In an advanced phase, DRAFT integrated AI-powered drafting tools (via HEROZ partnership) to optimize construction documentation workflows, which we highlighted using performance graphs and animation cues on the site.",
    ],

    tags: [
      {name: "HTML", color: "blue-text-gradient"},
      {name: "Graphs", color: "green-text-gradient"},
      {name: "CSS, SCSS, Bootstrap", color: "pink-text-gradient"},
      {name: "GSAP, Locomotive - Animation", color: "orange-text-gradient"},
    ],
    image: draft,
    websiteLink: "https://draft.co.jp/en/",
    isVideo: false,
  },
  // Dink Pickleball
  {
    name: "Dink Pickleball",
    description:
      "Dink Pickleball is an online platform built to facilitate court bookings, membership management, and player engagement for India's fastest-growing sport. It offers users a smooth interface to discover nearby venues and manage their sports activities seamlessly.",

    slug: "dink-pickleball",
    title: "Dink Pickleball",
    category: "Sports/Court Booking Platform",
    client: "DinkPickleball India",
    date: "Ongoing since 2024",
    location: "India",
    designer: "-",

    gridImages1: [DinkPickleball, DinkPickleballMobile],
    gridImages2: [
      DinkPickleballIpad,
      DinkPickleballScreen1,
      DinkPickleballScreen2,
    ],

    overviewParagraph1:
      "The project focuses on building a robust booking interface integrated with membership plans, real-time availability, and secure user accounts. The backend is powered by PHP CodeIgniter, while the frontend uses ReactJS to deliver a responsive, app-like experience across devices. Advanced notification services, including SMS and email automation, help users stay updated with court availability and booking confirmations.",

    overviewChecks: [
      "Convert all FIGMA DDesign into Reusable React Components",
      "Real-time court and time-slot booking system",
      "Admin panel to manage venues and memberships",
      "Integrated SMS and Email notifications",
      "Custom user dashboard and booking history",
      "Responsive design for mobile and desktop users",
    ],

    testingResultParagraphs: [
      "Extensive testing ensured seamless booking flows across devices, with special attention to mobile-first usability.",
      "All notification and payment processes were tested across edge cases such as double-booking, expired sessions, and member-only access validation.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "PHP CodeIgniter Backend",
        color: "green-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "pink-text-gradient",
      },
      {
        name: "SMS, Email Services",
        color: "orange-text-gradient",
      },
    ],

    image: DinkPickleball,
    websiteLink: "https://dinkpickleball.in/",
    isVideo: false,
  },
  // DeBook Magic key
  {
    name: "DeBook Magic key",
    description:
      "“Debook” empower authors to earn more by turning their book into a community, unfolding a new and enhanced reading experience for everyone!",
    slug: "“Debook-magic-key",
    title: "DeBook Magic key",
    category: "Read, self-publish, buy, resell & lend debooks",
    client: "Ernest Vinas",
    date: "25 sep 2024",
    location: "Barcelona, Spain",
    designer: "-",
    gridImages1: [debookFIG, debookFIGMobile],
    gridImages2: [debookFIGIpad, debookFIGScreen1, debookFIGScreen2],
    overviewParagraph1:
      "We transformed the DeBook Magic Key landing page from Figma into a fully responsive, component-based React structure using Next.js. The goal was to create a seamless and engaging Web3 product showcase with rich animations, performance optimization, and intuitive interactions.",
    overviewChecks: [
      "Converted Figma design into reusable Next.js components",
      "Implemented GSAP animations for smooth UI transitions",
      "Used CSS modules for scoped, maintainable styling",
      "Integrated NFT wallet features and Web3 logic",
      "Optimized for responsiveness and performance across devices",
    ],
    testingResultParagraphs: [
      "Project testing and results evaluation are critical steps to ensure the final product meets quality standards, functions seamlessly and delivers an exceptional user experience. This phase involves rigorous testing processes, including functional, performance, security, usability, and accessibility checks.",
      "Testing identified and resolved bugs, validated cross-browser and cross-device compatibility, and optimized the overall performance. After deployment, we monitored metrics and ensured a smooth Web3 interaction layer for all users.",
    ],
    tags: [
      {
        name: "Next JS",
        color: "blue-text-gradient",
      },
      {
        name: "javascript",
        color: "green-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "pink-text-gradient",
      },
      {
        name: "GSAP - Animation",
        color: "orange-text-gradient",
      },
    ],
    image: debookFIG,
    websiteLink: "https://www.debookmagickey.com/",
    isVideo: false,
  },
  //DeBook.App
  {
    name: "DebookApp Landing Page",
    description:
      "Debook empowers authors to build thriving communities around their books, offering readers a fresh, immersive, and interactive reading experience. The landing page was crafted to reflect the brand's vision and guide users smoothly into the ecosystem.",

    slug: "debookapp-landing",
    title: "DebookApp Landing Page",
    category: "Author Community Platform",
    client: "Ernest Vinas",
    date: "03 Jan 2024",
    location: "Barcelona, Spain",
    designer: "Provided Figma Design",

    gridImages1: [debppkapp, debppkapp],
    gridImages2: [debppkapp, debppkapp, debppkapp],

    overviewParagraph1:
      "This project involved converting a high-fidelity Figma design into a responsive and animated React.js landing page. The focus was on clear storytelling, smooth scroll effects, and a performance-optimized user experience that works seamlessly across devices.",

    overviewChecks: [
      "Figma to Pixel-Perfect React Conversion",
      "Animated Scroll Transitions and Reveal Effects",
      "Responsive Layout with SCSS Structure",
      "Hero Section with Interactive CTA Flow",
      "Optimized Build & Deployment via Vercel",
    ],

    testingResultParagraphs: [
      "The landing page was manually tested across all modern browsers and devices to ensure full responsiveness and animation smoothness.",
      "Deployment testing included Lighthouse audits to validate accessibility, performance, and SEO best practices.",
    ],

    tags: [
      {
        name: "React.js",
        color: "blue-text-gradient",
      },
      {
        name: "CSS, SCSS",
        color: "green-text-gradient",
      },
      {
        name: "Figma-design",
        color: "pink-text-gradient",
      },
      {
        name: "Animations",
        color: "orange-text-gradient",
      },
    ],

    image: debppkapp,
    websiteLink: "https://debook.app/",
    isVideo: false,
  },
  // Imgur (social gossip)
  {
    name: "Imgur (social gossip)",
    description:
      "Imgur is an American online image sharing and image hosting service with a focus on social gossip that was founded by Alan Schaaf in 2009.",
    slug: "Imgur-social-gossip",
    title: "Imgur (social gossip)",
    category: "Social Gossip - Image Hosting & image sharing",
    client: "Alan Schaaf",
    date: "06 Jan 2022",
    location: "Ohio, United States",
    designer: "-",
    gridImages1: [imgur, imgur],
    gridImages2: [imgur, imgur, imgur],

    overviewParagraph1:
      "I contributed to building a modern, responsive image-sharing social platform using React and SCSS. The focus was on enabling fast media uploads, real-time feed updates, and a gossip-style layout where users could upvote, comment, and discover viral content. The platform needed to scale for high traffic and deliver smooth performance across web and mobile browsers.",

    overviewChecks: [
      "Developed social feed layout with infinite scroll",
      "Implemented image upload with live preview and compression",
      "Created voting, commenting & trending logic in UI",
      "Used SCSS for modular and responsive styling",
      "Optimized UX for performance across mobile/desktop",
    ],

    testingResultParagraphs: [
      "I conducted frontend testing using a combination of device emulators and manual QA to ensure consistent layout rendering, image scaling, and responsiveness. Every user flow — posting, commenting, upvoting, and browsing — was verified.",
      "Edge cases like large image uploads, network throttling, and multi-user interactions were handled with fallback logic and loading states. Cross-browser compatibility and lazy loading were tested to ensure long-session performance.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "Javascript",
        color: "green-text-gradient",
      },
      {
        name: "SCSS",
        color: "pink-text-gradient",
      },
    ],
    image: imgur,
    websiteLink: "https://imgur.com/",
    isVideo: false,
  },
  // Yamaha Music Europe
  {
    name: "Yamaha Music Europe",
    description:
      "Electrify your performance with Yamaha Electric Guitars. Available in your favorite colors. Shop online for your favorite Yamaha Electric guitars.",
    slug: "yamaha-music-europe",
    title: "Yamaha Music Europe",
    category: "Musical Instruments & E-commerce",
    client: "Torakusu Yamaha",
    date: "20 Nov 2024",
    location: "San Diego, United States",
    designer: "-",
    gridImages1: [yamahaeurope, yamahaeurope],
    gridImages2: [yamahaeurope, yamahaeurope, yamahaeurope],

    overviewParagraph1:
      "I worked on the front-end development of Yamaha Music Europe’s e-commerce platform using Vue.js, turning Figma visuals into a live, interactive user experience. The project focused on showcasing musical instruments with rich product detail views, smooth animations, and an accessible shopping flow optimized for both desktop and mobile users.",

    overviewChecks: [
      "Converted Figma e-commerce design into Vue.js components",
      "Integrated responsive grid system for product displays",
      "Styled layouts using SCSS for modular maintainability",
      "Implemented product sliders, filters, and detail pages",
      "Ensured WCAG-compliant accessibility across all screens",
    ],

    testingResultParagraphs: [
      "The platform was thoroughly tested across multiple browsers and screen sizes, ensuring consistent layout rendering and accessibility compliance. We validated key e-commerce flows including navigation, product filtering, and checkout interactions.",
      "Animations, lazy loading, and mobile behavior were tested manually and using browser dev tools. Any edge cases, like price calculation issues or style inconsistencies, were resolved before deployment.",
    ],

    tags: [
      {
        name: "Vue.js",
        color: "blue-text-gradient",
      },
      {
        name: "CSS, SCSS",
        color: "green-text-gradient",
      },
      {
        name: "Figma-design",
        color: "pink-text-gradient",
      },
    ],
    image: yamahaeurope,
    websiteLink: "https://europe.yamaha.com/index.html",
    isVideo: false,
  },
  // Feedly
  {
    name: "Feedly",
    description:
      "Feedly is a news aggregator application for various web browsers and mobile devices running iOS and Android. It is also available as a cloud-based service.",
    slug: "feedly",
    title: "Feedly",
    category: "Productivity & News",
    client: "Edwin Khodabakchian",
    date: "30 Mar 2023",
    location: "California, United States",
    designer: "-",
    gridImages1: [feedly, feedly],
    gridImages2: [feedly, feedly, feedly],

    overviewParagraph1:
      "I contributed to Feedly’s web interface by transforming their modular layout designs into functional React components. The goal was to make reading, organizing, and saving content effortless across platforms while integrating third-party tools like Calendly for team collaboration and user onboarding.",

    overviewChecks: [
      "Converted modular layout into reusable React components",
      "Integrated RSS and category filtering with real-time updates",
      "Optimized list rendering for performance using lazy loading",
      "Integrated Calendly for embedded scheduling experiences",
      "Ensured dark mode and cross-browser UI consistency",
    ],

    testingResultParagraphs: [
      "All views were tested for responsiveness, list rendering performance, and content loading states using a combination of manual tests and browser automation tools.",
      "Edge cases such as broken feed URLs, pagination glitches, and theme toggling issues were resolved. Calendly integration was validated through staging with real-time session simulation.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "Javascript",
        color: "green-text-gradient",
      },
      {
        name: "Calendly",
        color: "pink-text-gradient",
      },
    ],
    image: feedly,
    websiteLink: "https://feedly.com/",
    isVideo: false,
  },
  // Aachho E-commerc
  {
    name: "Aachho E-commerce",
    description:
      "Created E-commerce based website for online shopping & buy the most stunning collections of designer ethnic dresses. The Aachho Birthday Sale is live.",
    slug: "aachho-e-commerce",
    title: "Aachho E-commerce",
    category: "E-commerce",
    client: "Rimjhim Hada and Anurag Singh Khangarot",
    date: "12 Jul 2023",
    location: "Jaipur, Rajasthan, India",
    designer: "-",
    gridImages1: [aachho, aachho],
    gridImages2: [aachho, aachho, aachho],

    overviewParagraph1:
      "For Aachho, I developed a high-conversion e-commerce website tailored for premium ethnic fashion. Built with React.js and styled using SCSS, the platform integrates sleek design with responsive product grids, filter logic, and campaign-ready promotional banners—all crafted from Figma designs into optimized, scalable components.",

    overviewChecks: [
      "Converted Figma designs into functional React.js components",
      "Implemented SCSS-based responsive layouts for mobile and desktop",
      "Built reusable product grid, filter, and cart modules",
      "Integrated seasonal sales and banner promo logic",
      "Ensured smooth UX from browsing to checkout",
    ],

    testingResultParagraphs: [
      "Tested all user flows—homepage to product pages to checkout—across devices to ensure responsiveness, animation stability, and error-free routing.",
      "Cross-browser testing included Safari, Firefox, Chrome, and Edge. Minor layout inconsistencies were fixed using SCSS media queries and conditional rendering.",
    ],

    tags: [
      {
        name: "React.js",
        color: "blue-text-gradient",
      },
      {
        name: "CSS, SCSS",
        color: "green-text-gradient",
      },
      {
        name: "Figma-design",
        color: "pink-text-gradient",
      },
    ],
    image: aachho,
    websiteLink: "https://aachho.com/",
    isVideo: false,
  },
];

// 📦 Project Data Array
const projects = [
  // Dink Pickleball
  {
    name: "Dink Pickleball",
    description:
      "Dink Pickleball is an online platform built to facilitate court bookings, membership management, and player engagement for India's fastest-growing sport. It offers users a smooth interface to discover nearby venues and manage their sports activities seamlessly.",

    slug: "dink-pickleball",
    title: "Dink Pickleball",
    category: "Sports/Court Booking Platform",
    client: "DinkPickleball India",
    date: "Ongoing since 2024",
    location: "India",
    designer: "-",

    gridImages1: [DinkPickleball, DinkPickleballMobile],
    gridImages2: [
      DinkPickleballIpad,
      DinkPickleballScreen1,
      DinkPickleballScreen2,
    ],

    overviewParagraph1:
      "The project focuses on building a robust booking interface integrated with membership plans, real-time availability, and secure user accounts. The backend is powered by PHP CodeIgniter, while the frontend uses ReactJS to deliver a responsive, app-like experience across devices. Advanced notification services, including SMS and email automation, help users stay updated with court availability and booking confirmations.",

    overviewChecks: [
      "Convert all FIGMA DDesign into Reusable React Components",
      "Real-time court and time-slot booking system",
      "Admin panel to manage venues and memberships",
      "Integrated SMS and Email notifications",
      "Custom user dashboard and booking history",
      "Responsive design for mobile and desktop users",
    ],

    testingResultParagraphs: [
      "Extensive testing ensured seamless booking flows across devices, with special attention to mobile-first usability.",
      "All notification and payment processes were tested across edge cases such as double-booking, expired sessions, and member-only access validation.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "PHP CodeIgniter Backend",
        color: "green-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "pink-text-gradient",
      },
      {
        name: "SMS, Email Services",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Dink Pickleball | Sports Booking Web App by Deep Kapadia",
      description:
        "Dink Pickleball is a custom-built booking platform developed by Deep Kapadia, using ReactJS and PHP CodeIgniter. It supports real-time court bookings, membership management, and notification systems tailored for India's fast-growing pickleball community.",
      keywords:
        "Dink Pickleball, Sports/Court Booking Platform, Court Booking React App, PHP CodeIgniter, Deep Kapadia Projects, Figma to React, Membership System",
    },
    image: DinkPickleball,
    websiteLink: "https://dinkpickleball.in/",
    isVideo: false,
  },
  // Thrivea HR platform
  {
    name: "Thrivea",
    description:
      "THRIVEA is a fresh, innovative HR platform best suited for small and medium enterprises on a growth path. Their design team provided polished Figma designs, and my role was to bring those to life on the web with pixel-perfect precision, performance optimization, and responsive behavior.",
    slug: "thrivea-hr-platform",
    title: "Thrivea",
    category: "HR platform - SAAS",
    client: "Ivan Stantic",
    date: "11 Aug 2024",
    location: "USA",
    designer: "Provided by client",
    gridImages1: [thrivea, thriveaMobile],
    gridImages2: [thriveaIpad, thriveaScreen1, thriveaScreen2],

    overviewParagraph1:
      "For Thrivea, I was responsible for converting their detailed Figma designs into a fully functional, responsive web experience. The focus was on maintaining design accuracy while ensuring smooth performance across devices and browsers. Every screen was carefully implemented to match the intended brand identity and usability goals.",

    overviewChecks: [
      "Delivered pixel-perfect Figma to code conversion",
      "Built responsive layouts optimized for desktop, tablet, and mobile",
      "Used React / Next.js with modular, reusable components",
      "Applied Tailwind CSS for rapid styling and scalability",
      "Ensured accessibility standards and cross-browser consistency",
    ],

    overviewParagraph2:
      "The Thrivea platform emphasizes simplicity, employee-centric design, and scalable HR operations. My role was to make sure their product vision translated seamlessly into the web interface without compromising on performance or user experience.",

    overviewParagraph3:
      "This project involved close collaboration with the client to align design intent with technical feasibility. The end result was a polished, responsive platform that stayed true to the original Figma while being production-ready and scalable.",

    testingResultParagraphs: [
      "Conducted detailed QA testing to verify responsiveness across desktop, tablet, and mobile breakpoints.",
      "Validated animations, transitions, and component behaviors to ensure smooth and consistent user experience.",
      "Performed cross-browser checks (Chrome, Safari, Firefox, Edge) to ensure layout and functionality integrity.",
    ],

    tags: [
      {name: "Tailwind CSS", color: "blue-text-gradient"},
      {name: "HTML", color: "green-text-gradient"},
      {name: "JavaScript", color: "pink-text-gradient"},
      {name: "React / Next.js", color: "orange-text-gradient"},
    ],
    image: thrivea,
    websiteLink: "https://thrivea.devplace.fun/", // replace with actual Thrivea link if available
    isVideo: false,
  },
  // Draft inc. Japan
  {
    name: "Draft",
    description:
      "Draft is a design studio founded by Taiju Yamashita in 2008. With a focus on interior design, product design, and architectural design from urban development to branding.",
    slug: "draft-inc",
    title: "Draft inc. Japan",
    category: "Architecture & Interior",
    client: "Taiju Yamashita",
    date: "25 Sep 2024",
    location: "USA",
    designer: "-",
    gridImages1: [draft, draftMobile],
    gridImages2: [draftIpad, draftScreen1, draftScreen2],

    overviewParagraph1:
      "At DRAFT, I helped translate their design philosophy—'ALL HAPPY BY DESIGN'—into a visually rich and performance-optimized web experience. The site showcases their multidisciplinary approach across architecture, interiors, product design, and branding. Using animation frameworks and scoped styling, the focus was on mirroring their immersive, people-centric spaces through a responsive, modern interface.",

    overviewChecks: [
      "Built interactive layouts that echo real-world spatial design principles",
      "Used GSAP and Locomotive Scroll for immersive, scroll-based storytelling",
      "Translated brand values into modular HTML/CSS components",
      "Integrated graph/data views to support case studies and project showcases",
      "Ensured cross-platform accessibility and smooth user experience",
    ],

    overviewParagraph2:
      "DRAFT, under the philosophy of “ALL HAPPY BY DESIGN,” pursues unlocking the potential of space and shaping how people interact with environments, aiming to create designs that bring happiness through innovative architecture, interior, product, and branding solutions.",

    overviewParagraph3:
      "Founded in April 2008 by architect Taiju Yamashita, DRAFT began with office interiors and grew into large-scale spaces, furniture brands such as DAFT about DRAFT and urban development, with global studios and subsidiaries in the Philippines and Serbia.",

    testingResultParagraphs: [
      "The website underwent detailed QA testing including scroll behavior validation, GSAP animation consistency, and layout integrity across all major screen sizes and browsers.",
      "CSS/SCSS modules were validated for responsiveness, and Bootstrap components were tested to handle variable content blocks and multilingual expansion.",
      "In an advanced phase, DRAFT integrated AI-powered drafting tools (via HEROZ partnership) to optimize construction documentation workflows, which we highlighted using performance graphs and animation cues on the site.",
    ],

    tags: [
      {name: "HTML", color: "blue-text-gradient"},
      {name: "Graphs", color: "green-text-gradient"},
      {name: "CSS, SCSS, Bootstrap", color: "pink-text-gradient"},
      {name: "GSAP, Locomotive - Animation", color: "orange-text-gradient"},
    ],
    // ✅ SEO data
    SEO: {
      title:
        "Draft Inc. Japan | Architecture & Interior Portfolio by Deep Kapadia",
      description:
        "Discover the digital portfolio for Draft Inc — a multidisciplinary design studio founded by Taiju Yamashita. Developed by Deep Kapadia with GSAP animations, smooth scroll UX, and responsive layouts that reflect architectural and spatial storytelling.",
      keywords:
        "Draft Inc, Taiju Yamashita, Architecture Web Design, Interior Design Website, GSAP Scroll Animation, Locomotive Scroll, Design Studio Japan, Deep Kapadia Projects, Figma to Code, Responsive Design Portfolio",
    },
    image: draft,
    websiteLink: "https://draft.co.jp/en/",
    isVideo: false,
  },
  // Imgur (social gossip)
  {
    name: "Imgur (social gossip)",
    description:
      "Imgur is an American online image sharing and image hosting service with a focus on social gossip that was founded by Alan Schaaf in 2009.",
    slug: "Imgur-social-gossip",
    title: "Imgur (social gossip)",
    category: "Social Gossip - Image Hosting & image sharing",
    client: "Alan Schaaf",
    date: "06 Jan 2022",
    location: "Ohio, United States",
    designer: "-",
    gridImages1: [imgur, imgurMobile],
    gridImages2: [imgurIpad, imgurScreen1, imgurScreen2],

    overviewParagraph1:
      "I contributed to building a modern, responsive image-sharing social platform using React and SCSS. The focus was on enabling fast media uploads, real-time feed updates, and a gossip-style layout where users could upvote, comment, and discover viral content. The platform needed to scale for high traffic and deliver smooth performance across web and mobile browsers.",

    overviewChecks: [
      "Developed social feed layout with infinite scroll",
      "Implemented image upload with live preview and compression",
      "Created voting, commenting & trending logic in UI",
      "Used SCSS for modular and responsive styling",
      "Optimized UX for performance across mobile/desktop",
    ],

    testingResultParagraphs: [
      "I conducted frontend testing using a combination of device emulators and manual QA to ensure consistent layout rendering, image scaling, and responsiveness. Every user flow — posting, commenting, upvoting, and browsing — was verified.",
      "Edge cases like large image uploads, network throttling, and multi-user interactions were handled with fallback logic and loading states. Cross-browser compatibility and lazy loading were tested to ensure long-session performance.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "Javascript",
        color: "green-text-gradient",
      },
      {
        name: "SCSS",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Imgur Social Gossip | Image Sharing Web App by Deep Kapadia",
      description:
        "Explore Imgur's social gossip image-sharing platform — built with React and SCSS, this project features real-time feed updates, media uploads, upvotes, and responsive UI for viral content discovery.",
      keywords:
        "Imgur, Social Image Sharing Platform, React Social Feed, Deep Kapadia Projects, Image Upload App, Gossip Website, SCSS UI, Infinite Scroll, Upvote Feed UI",
    },

    image: imgur,
    websiteLink: "https://imgur.com/",
    isVideo: false,
  },
  // Dashboard Admin Pickleball
  {
    name: "Dashboard Admin Panel",
    description:
      "The Pickleball Admin Dashboard is a backend management platform for venue owners, enabling them to handle court bookings, memberships, and user management for the rapidly growing sport of pickleball. It simplifies scheduling, tracks booking analytics, and integrates communication tools for operational efficiency.",

    slug: "pickleball-admin-panel",
    title: "Pickleball Admin Panel",
    category: "Sports Management System",
    client: "DinkPickleball India",
    date: "Ongoing since 2024",
    location: "India",
    designer: "-",

    gridImages1: [pickleballAdmin, pickleballAdminMobile],
    gridImages2: [
      pickleballAdminIpad,
      pickleballAdminScreen1,
      pickleballAdminScreen2,
    ],

    overviewParagraph1:
      "The Admin Panel is crafted to empower venue partners with full control over their operations — from managing daily court schedules to sending instant confirmations and promotional notifications. Built with PHP CodeIgniter for stability and performance, and enhanced with JQuery-powered UI for efficient interaction, it provides a seamless experience for admins and staff alike.",

    overviewChecks: [
      "Manage and view all upcoming bookings",
      "Create, update, and monitor membership plans",
      "Automated SMS and Email alerts for users",
      "View booking analytics and court usage stats",
      "Access control for different admin roles",
    ],

    testingResultParagraphs: [
      "Thorough QA testing was conducted to validate booking logic, access roles, and notification flows.",
      "Stress-tested for multi-admin interactions and booking concurrency, ensuring reliability during high-demand hours.",
    ],

    tags: [
      {
        name: "PHP CodeIgniter Backend",
        color: "blue-text-gradient",
      },
      {
        name: "HTML, CSS, JS, JQuery",
        color: "pink-text-gradient",
      },
      {
        name: "SMS, Email Services",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Pickleball Admin Panel | Backend Dashboard by Deep Kapadia",
      description:
        "Explore the Pickleball Admin Panel — a custom backend dashboard for venue owners to manage bookings, memberships, and user data, built with PHP CodeIgniter and optimized by Deep Kapadia.",
      keywords:
        "Pickleball Admin Panel, Sports Management System, Court Booking Backend, PHP CodeIgniter, Admin Dashboard UI, Deep Kapadia Projects, Venue Booking Platform",
    },
    image: pickleballAdmin,
    websiteLink: "https://dinkpickleball.in/",
    isVideo: false,
  },
  // PickleballMe
  {
    name: "PickleballMe",
    description:
      "Pickleball is the fastest-growing sport in the world right now. This platform is designed to book courts and memberships for nearby venues.",
    slug: "PickleballMe",
    title: "PickleballMe",
    category: "Pickleball & Sports Booking",
    client: "Vishwaraj Jadeja",
    date: "21 Nov 2024",
    location: "India",
    designer: "-",
    gridImages1: [pickleballMe, pickleballMeMobile],
    gridImages2: [pickleballMeIpad, pickleballMeScreen1, pickleballMeScreen2],

    overviewParagraph1:
      "I developed a full-featured booking platform for PickleballMe using React and a CodeIgniter backend. The system enables users to easily search and book nearby courts, manage memberships, and receive real-time updates through SMS and email services. The platform emphasizes clean UI, intuitive booking flows, and robust admin control for venue managers.",

    overviewChecks: [
      "Built court booking flow with date and time slot logic",
      "Integrated PHP CodeIgniter APIs for venue, user, and booking management",
      "Added SMS and email notifications for real-time booking alerts",
      "Implemented wallet balance, user subscriptions & membership logic",
      "Created responsive UI with reusable React components",
    ],

    testingResultParagraphs: [
      "Before deployment, I conducted full-functionality tests across all modules—booking, registration, payments, and notifications. Each feature was tested on staging and reviewed for consistent performance across major devices and browsers.",
      "I resolved edge case bugs during slot overlaps, and ensured real-time status sync for bookings. Load testing was done using fake data to simulate high traffic, and automated alerts were added for API errors.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "PHP CodeIgniter Backend",
        color: "green-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "pink-text-gradient",
      },
      {
        name: "SMS, Email Services",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "PickleballMe | Court Booking Platform by Deep Kapadia",
      description:
        "PickleballMe is a court and membership booking platform developed by Deep Kapadia using ReactJS and PHP CodeIgniter. It enables real-time venue management, intuitive slot booking, and automated SMS/email notifications for users and admins.",
      keywords:
        "PickleballMe, Court Booking System, Sports/Court Booking Platform, ReactJS Booking App, PHP CodeIgniter, Deep Kapadia Projects, Membership Booking App, Sports Venue Platform",
    },

    image: pickleballMe,
    websiteLink: "https://pickleball.me.in/",
    isVideo: false,
  },
  // DeBook Magic key
  {
    name: "DeBook Magic key",
    description:
      "“Debook” empower authors to earn more by turning their book into a community, unfolding a new and enhanced reading experience for everyone!",
    slug: "“Debook-magic-key",
    title: "DeBook Magic key",
    category: "Read, self-publish, buy, resell & lend debooks",
    client: "Ernest Vinas",
    date: "25 sep 2024",
    location: "Barcelona, Spain",
    designer: "-",
    gridImages1: [debookFIG, debookFIGMobile],
    gridImages2: [debookFIGIpad, debookFIGScreen1, debookFIGScreen2],
    overviewParagraph1:
      "We transformed the DeBook Magic Key landing page from Figma into a fully responsive, component-based React structure using Next.js. The goal was to create a seamless and engaging Web3 product showcase with rich animations, performance optimization, and intuitive interactions.",
    overviewChecks: [
      "Converted Figma design into reusable Next.js components",
      "Implemented GSAP animations for smooth UI transitions",
      "Used CSS modules for scoped, maintainable styling",
      "Integrated NFT wallet features and Web3 logic",
      "Optimized for responsiveness and performance across devices",
    ],
    testingResultParagraphs: [
      "Project testing and results evaluation are critical steps to ensure the final product meets quality standards, functions seamlessly and delivers an exceptional user experience. This phase involves rigorous testing processes, including functional, performance, security, usability, and accessibility checks.",
      "Testing identified and resolved bugs, validated cross-browser and cross-device compatibility, and optimized the overall performance. After deployment, we monitored metrics and ensured a smooth Web3 interaction layer for all users.",
    ],
    tags: [
      {
        name: "Next JS",
        color: "blue-text-gradient",
      },
      {
        name: "javascript",
        color: "green-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "pink-text-gradient",
      },
      {
        name: "GSAP - Animation",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "DeBook Magic Key | Web3 Landing Page by Deep Kapadia",
      description:
        "Explore the Web3-powered DeBook Magic Key platform — a Figma to Next.js conversion by Deep Kapadia featuring GSAP animations, NFT wallet integrations, and responsive component-based design.",
      keywords:
        "DeBook Magic Key, Web3 Landing Page, NFT Wallet Integration, GSAP Animations, Deep Kapadia Projects, Figma to Next.js, React Component Design, Responsive UI Web3, Frontend Blockchain Project",
    },
    image: debookFIG,
    websiteLink: "https://www.debookmagickey.com/",
    isVideo: false,
  },
  //DeBook.App
  {
    name: "DebookApp Landing Page",
    description:
      "Debook empowers authors to build thriving communities around their books, offering readers a fresh, immersive, and interactive reading experience. The landing page was crafted to reflect the brand's vision and guide users smoothly into the ecosystem.",

    slug: "debookapp-landing",
    title: "DebookApp Landing Page",
    category: "Author Community Platform",
    client: "Ernest Vinas",
    date: "03 Jan 2024",
    location: "Barcelona, Spain",
    designer: "Provided Figma Design",

    gridImages1: [debppkapp, debppkappMobile],
    gridImages2: [debppkappIpad, debppkappScreen1, debppkappScreen2],

    overviewParagraph1:
      "This project involved converting a high-fidelity Figma design into a responsive and animated React.js landing page. The focus was on clear storytelling, smooth scroll effects, and a performance-optimized user experience that works seamlessly across devices.",

    overviewChecks: [
      "Figma to Pixel-Perfect React Conversion",
      "Animated Scroll Transitions and Reveal Effects",
      "Responsive Layout with SCSS Structure",
      "Hero Section with Interactive CTA Flow",
      "Optimized Build & Deployment via Vercel",
    ],

    testingResultParagraphs: [
      "The landing page was manually tested across all modern browsers and devices to ensure full responsiveness and animation smoothness.",
      "Deployment testing included Lighthouse audits to validate accessibility, performance, and SEO best practices.",
    ],

    tags: [
      {
        name: "React.js",
        color: "blue-text-gradient",
      },
      {
        name: "CSS, SCSS",
        color: "green-text-gradient",
      },
      {
        name: "Figma-design",
        color: "pink-text-gradient",
      },
      {
        name: "Animations",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "DebookApp Landing Page | React Web Design by Deep Kapadia",
      description:
        "Discover the DebookApp landing page — crafted from Figma into a responsive React build, featuring animations, scroll effects, and performance-focused deployment for a Web3 reading experience.",
      keywords:
        "DebookApp, Web3 Landing Page, Figma to React, Author Community Platform, React.js Portfolio, Animated Landing Page, Deep Kapadia Projects, Responsive Web Design",
    },

    image: debppkapp,
    websiteLink: "https://debook.app/",
    isVideo: false,
  },
  // Sundown Studio
  {
    name: "Sundown Studio",
    description:
      "Sundown is a multi-disciplinary studio focused on creating unique, end-to-end experiences and environments. The best studio at one place.",
    slug: "sundown-studio",
    title: "Sundown Studio",
    category: "Music Studio & Music Production",
    client: "Alan Schaaf",
    date: "21 Feb 2022",
    location: "Marsh Cl, Australia",
    designer: "-",
    gridImages1: [sundownStudio, sundownStudioMobile],
    gridImages2: [
      sundownStudioIpad,
      sundownStudioScreen1,
      sundownStudioScreen2,
    ],

    overviewParagraph1:
      "For Sundown Studio, I developed a dynamic web presence that reflects the creative and immersive essence of the studio. Built using React and Redux, the platform highlights studio work, showcases environment visuals, and manages user interactions across various sections. Emphasis was placed on animations, content structure, and seamless responsiveness across all devices.",

    overviewChecks: [
      "Converted Figma sections into functional React components",
      "Used Redux for managing global UI states and interactions",
      "Designed smooth scroll-triggered effects and content fades",
      "Built dynamic gallery sections and image grid components",
      "Ensured pixel-perfect responsive layout across screen sizes",
    ],

    testingResultParagraphs: [
      "Each component and route was tested on local and staging environments to ensure layout consistency and interaction flow. Responsive testing was carried out on multiple devices and screen breakpoints.",
      "Scroll-triggered transitions were tested using manual and browser-based tools. Cross-browser checks were completed, and optimizations were made to image loading and animation performance before deploying to Vercel.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "Redux",
        color: "green-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "pink-text-gradient",
      },
    ],

    // ✅ SEO data
    SEO: {
      title: "Sundown Studio | Creative Studio Website by Deep Kapadia",
      description:
        "Discover the Sundown Studio website — a creative showcase built with React and Redux, featuring immersive visuals, smooth animations, and a responsive layout inspired by Figma design transitions.",
      keywords:
        "Sundown Studio, Creative Web Studio, React Redux Showcase, Deep Kapadia Projects, Figma to React Website, Music Studio Web Design, Smooth Scroll Animation",
    },

    image: sundownStudio,
    websiteLink: "https://sundown-ivory.vercel.app/",
    isVideo: false,
  },
  // Yamaha Music Europe
  {
    name: "Yamaha Music Europe",
    description:
      "Electrify your performance with Yamaha Electric Guitars. Available in your favorite colors. Shop online for your favorite Yamaha Electric guitars.",
    slug: "yamaha-music-europe",
    title: "Yamaha Music Europe",
    category: "Musical Instruments & E-commerce",
    client: "Torakusu Yamaha",
    date: "20 Nov 2024",
    location: "San Diego, United States",
    designer: "-",
    gridImages1: [yamahaeurope, yamahaeuropeMobile],
    gridImages2: [yamahaeuropeIpad, yamahaeuropeScreen1, yamahaeuropeScreen2],

    overviewParagraph1:
      "I worked on the front-end development of Yamaha Music Europe’s e-commerce platform using Vue.js, turning Figma visuals into a live, interactive user experience. The project focused on showcasing musical instruments with rich product detail views, smooth animations, and an accessible shopping flow optimized for both desktop and mobile users.",

    overviewChecks: [
      "Converted Figma e-commerce design into Vue.js components",
      "Integrated responsive grid system for product displays",
      "Styled layouts using SCSS for modular maintainability",
      "Implemented product sliders, filters, and detail pages",
      "Ensured WCAG-compliant accessibility across all screens",
    ],

    testingResultParagraphs: [
      "The platform was thoroughly tested across multiple browsers and screen sizes, ensuring consistent layout rendering and accessibility compliance. We validated key e-commerce flows including navigation, product filtering, and checkout interactions.",
      "Animations, lazy loading, and mobile behavior were tested manually and using browser dev tools. Any edge cases, like price calculation issues or style inconsistencies, were resolved before deployment.",
    ],

    tags: [
      {
        name: "Vue.js",
        color: "blue-text-gradient",
      },
      {
        name: "CSS, SCSS",
        color: "green-text-gradient",
      },
      {
        name: "Figma-design",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Yamaha Music Europe | E-commerce Frontend by Deep Kapadia",
      description:
        "Explore the Yamaha Music Europe platform — a Vue.js-powered e-commerce experience built from Figma, featuring dynamic product displays, responsive layouts, and optimized UX for musical instrument sales.",
      keywords:
        "Yamaha Music Europe, E-commerce Vue.js, Musical Instrument Website, Figma to Vue, Yamaha Guitars, SCSS Layout, Deep Kapadia Projects, Frontend Development",
    },

    image: yamahaeurope,
    websiteLink: "https://europe.yamaha.com/index.html",
    isVideo: false,
  },
  // Rejouice
  {
    name: "Rejouice | The Venture Agency",
    description:
      "Venture firm and digital agency turning bold visions into remarkable brands. Choose traditional compensation or an equity offset through our Venture model.",
    slug: "rejouice-the-venture-agency",
    title: "Rejouice | The Venture Agency",
    category: "Music Studio & Music Production",
    client: "Guillaume Hamon",
    date: "20 Apr 2022",
    location: "San Diego, United States",
    designer: "-",
    gridImages1: [rejouice, rejouiceMobile],
    gridImages2: [rejouiceIpad, rejouiceScreen1, rejouiceScreen2],

    overviewParagraph1:
      "For Rejouice, I developed a bold and immersive front-end experience to showcase their venture agency portfolio. The project used React and Redux for scalable state management, while focusing on performance-driven design with subtle animation cues and smooth content transitions to elevate the storytelling and brand experience.",

    overviewChecks: [
      "Converted interactive Figma layout into functional React views",
      "Used Redux to handle full-page navigation and state tracking",
      "Integrated scroll-based reveal animations and transitions",
      "Developed dynamic content sections and hover effects",
      "Ensured consistent responsive behavior with custom breakpoints",
    ],

    testingResultParagraphs: [
      "I performed extensive testing across breakpoints and screen types, ensuring the animation logic didn't break layout consistency. All major features were QA tested manually in staging.",
      "Stress testing was done on animation triggers, large image components, and navigation performance. Bugs were resolved around scroll locks and event propagation for smoother transitions.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "Redux",
        color: "green-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Rejouice | Bold Venture Agency Website by Deep Kapadia",
      description:
        "Explore the immersive Rejouice agency site — developed with React and Redux, this platform combines creative animations, smooth transitions, and a responsive layout to highlight a world-class venture agency.",
      keywords:
        "Rejouice Venture Agency, Creative Agency Website, React Redux Portfolio, Deep Kapadia Projects, Figma to React Build, Scroll Animation Website, Interactive Web Experience",
    },

    image: rejouice,
    websiteLink: "https://www.rejouice.com/",
    isVideo: false,
  },
  // Feedly
  {
    name: "Feedly",
    description:
      "Feedly is a news aggregator application for various web browsers and mobile devices running iOS and Android. It is also available as a cloud-based service.",
    slug: "feedly",
    title: "Feedly",
    category: "Productivity & News",
    client: "Edwin Khodabakchian",
    date: "30 Mar 2023",
    location: "California, United States",
    designer: "-",
    gridImages1: [feedly, feedlyMobile],
    gridImages2: [feedlyIpad, feedlyScreen1, feedlyScreen2],

    overviewParagraph1:
      "I contributed to Feedly’s web interface by transforming their modular layout designs into functional React components. The goal was to make reading, organizing, and saving content effortless across platforms while integrating third-party tools like Calendly for team collaboration and user onboarding.",

    overviewChecks: [
      "Converted modular layout into reusable React components",
      "Integrated RSS and category filtering with real-time updates",
      "Optimized list rendering for performance using lazy loading",
      "Integrated Calendly for embedded scheduling experiences",
      "Ensured dark mode and cross-browser UI consistency",
    ],

    testingResultParagraphs: [
      "All views were tested for responsiveness, list rendering performance, and content loading states using a combination of manual tests and browser automation tools.",
      "Edge cases such as broken feed URLs, pagination glitches, and theme toggling issues were resolved. Calendly integration was validated through staging with real-time session simulation.",
    ],

    tags: [
      {
        name: "React JS",
        color: "blue-text-gradient",
      },
      {
        name: "Javascript",
        color: "green-text-gradient",
      },
      {
        name: "Calendly",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Feedly | React News Aggregator Interface by Deep Kapadia",
      description:
        "Discover how Deep Kapadia contributed to Feedly — building modular React components, real-time RSS filtering, and Calendly integrations for a seamless content aggregation experience.",
      keywords:
        "Feedly React Development, News Aggregator UI, RSS Feed App, Calendly Integration, Deep Kapadia Projects, Modular Layouts, Productivity Web App, Dark Mode Interface",
    },

    image: feedly,
    websiteLink: "https://feedly.com/",
    isVideo: false,
  },
  // BlueStone
  {
    name: "BlueStone",
    description:
      "BlueStone Web-Application to Buy Gold and Diamond Jewellery Online in India with the latest jewellery designs 2023 from our online jewellery shopping store",
    slug: "bluestone",
    title: "BlueStone",
    category: "Jawellery E-commerce",
    client: "Gaurav Singh Kushwaha",
    date: "06 Jan 2022",
    location: "India",
    designer: "-",
    gridImages1: [bluestone, bluestoneMobile],
    gridImages2: [bluestoneIpad, bluestoneScreen1, bluestoneScreen2],

    overviewParagraph1:
      "I contributed to the BlueStone e-commerce platform by enhancing its PHP CodeIgniter-based backend and implementing responsive, conversion-focused UI using SCSS and Bootstrap. The platform showcases a wide range of gold and diamond jewellery with advanced filtering, cart, and checkout logic tailored for the Indian market.",

    overviewChecks: [
      "Developed category and filter-based product listing views",
      "Enhanced checkout process with address, coupon, and payment modules",
      "Refined UI with responsive layouts using SCSS and Bootstrap",
      "Built admin panel modules for order and inventory management",
      "Handled image zoom, wishlist, and dynamic product pages",
    ],

    testingResultParagraphs: [
      "The application was tested thoroughly across key flows including product browsing, cart functionality, and checkout. Device-specific CSS issues were addressed to ensure consistency on mobile and desktop.",
      "Functional testing included user sessions, order placement, and cart validations. Admin-side modules were tested with test data to simulate real-world inventory and order flows.",
    ],

    tags: [
      {
        name: "PHP",
        color: "blue-text-gradient",
      },
      {
        name: "CodeIgniter",
        color: "green-text-gradient",
      },
      {
        name: "CSS, SCSS, Bootstrap",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "BlueStone | Jewellery E-commerce Platform by Deep Kapadia",
      description:
        "Explore how Deep Kapadia contributed to BlueStone’s PHP CodeIgniter platform — enhancing jewellery browsing, cart logic, and admin modules for India’s premium e-commerce store.",
      keywords:
        "BlueStone Jewellery, E-commerce Website, PHP CodeIgniter, Deep Kapadia Projects, Gold and Diamond Online Store, Bootstrap UI, Responsive Jewellery Platform",
    },

    image: bluestone,
    websiteLink: "https://www.bluestone.com/",
    isVideo: false,
  },
  // MilkGarage
  {
    name: "MilkGarage",
    description:
      "Web application that provides unlimited access to Hong Kong's largest flexible co-workspace network. We built this for ourselves. Now you can use it too.",
    slug: "milkgarage",
    title: "MilkGarage",
    category: "Coworking Space & Booking",
    client: "Fangyu Wu",
    date: "26 Apr 2023",
    location: "Hong Kong, China",
    designer: "-",
    gridImages1: [milkgarage, milkgarageMobile],
    gridImages2: [],

    overviewParagraph1:
      "For MilkGarage, I built a flexible booking and coworking platform tailored for the Hong Kong market. The focus was on converting the internal workspace solution into a public product—supporting location-based discovery, workspace previews with SlickJS sliders, and seamless booking experiences via a responsive and branded front-end tied to a custom PHP backend (PIG).",

    overviewChecks: [
      "Converted internal dashboard into public-facing booking UI",
      "Integrated Slick JS for space sliders and carousels",
      "Used SCSS and Bootstrap to create mobile-responsive layouts",
      "Developed dynamic location and availability filtering",
      "Linked frontend forms with PHP(PIG)-based booking system",
    ],

    testingResultParagraphs: [
      "Tested the platform’s booking and location modules on real devices in varying network conditions to ensure fast load times and consistent availability display.",
      "Slider transitions, location toggling, and user input validations were manually tested for edge cases. PHP form processing was debugged and verified through staging logs.",
    ],

    tags: [
      {
        name: "Slick JS",
        color: "blue-text-gradient",
      },
      {
        name: "PHP(PIG)",
        color: "green-text-gradient",
      },
      {
        name: "CSS, SCSS, Bootstrap",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "MilkGarage | Coworking Booking Platform by Deep Kapadia",
      description:
        "Deep Kapadia transformed MilkGarage into a dynamic coworking space booking app with location filtering, responsive UI, SlickJS sliders, and a custom PHP(PIG) backend.",
      keywords:
        "MilkGarage Coworking, Booking Platform, Hong Kong Co-work Space, PHP(PIG) Backend, Deep Kapadia Projects, SlickJS Carousel, SCSS Bootstrap UI",
    },

    image: milkgarage,
    websiteLink: "https://milkgarage.com/",
    isVideo: false,
  },
  // Aachho E-commerc
  {
    name: "Aachho E-commerce",
    description:
      "Created E-commerce based website for online shopping & buy the most stunning collections of designer ethnic dresses. The Aachho Birthday Sale is live.",
    slug: "aachho-e-commerce",
    title: "Aachho E-commerce",
    category: "E-commerce",
    client: "Rimjhim Hada and Anurag Singh Khangarot",
    date: "12 Jul 2023",
    location: "Jaipur, Rajasthan, India",
    designer: "-",
    gridImages1: [aachho, aachhoMobile],
    gridImages2: [aachhoIpad, aachhoScreen1, aachhoScreen2],

    overviewParagraph1:
      "For Aachho, I developed a high-conversion e-commerce website tailored for premium ethnic fashion. Built with React.js and styled using SCSS, the platform integrates sleek design with responsive product grids, filter logic, and campaign-ready promotional banners—all crafted from Figma designs into optimized, scalable components.",

    overviewChecks: [
      "Converted Figma designs into functional React.js components",
      "Implemented SCSS-based responsive layouts for mobile and desktop",
      "Built reusable product grid, filter, and cart modules",
      "Integrated seasonal sales and banner promo logic",
      "Ensured smooth UX from browsing to checkout",
    ],

    testingResultParagraphs: [
      "Tested all user flows—homepage to product pages to checkout—across devices to ensure responsiveness, animation stability, and error-free routing.",
      "Cross-browser testing included Safari, Firefox, Chrome, and Edge. Minor layout inconsistencies were fixed using SCSS media queries and conditional rendering.",
    ],

    tags: [
      {
        name: "React.js",
        color: "blue-text-gradient",
      },
      {
        name: "CSS, SCSS",
        color: "green-text-gradient",
      },
      {
        name: "Figma-design",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Aachho E-commerce | Ethnic Fashion Store by Deep Kapadia",
      description:
        "Explore how Deep Kapadia developed Aachho’s premium e-commerce site — from Figma to React with responsive SCSS layouts, product filters, and campaign-ready UI for a seamless ethnic fashion shopping experience.",
      keywords:
        "Aachho, Ethnic Wear E-commerce, Aachho Jaipur, React JS Storefront, Deep Kapadia Projects, SCSS Layouts, Figma to React, Aachho Birthday Sale",
    },

    image: aachho,
    websiteLink: "https://aachho.com/",
    isVideo: false,
  },
  // Bunaai E-commerc
  {
    name: "Bunaai E-commerce",
    description:
      "Created E-commerce based website for online shopping & Get handpainted sarees, lehengas, suitsets and more on sale. Explore the latest fashion styles from Bunaai.",
    slug: "bunaai-e-commerce",
    title: "Bunaai E-commerce",
    category: "E-commerce",
    client: "Pari Choudhary",
    date: "06 Sep 2023",
    location: "Jaipur, Rajasthan, India",
    designer: "-",
    gridImages1: [bunaai, bunaaiMobile],
    gridImages2: [bunaaiIpad, bunaaiScreen1, bunaaiScreen2],

    overviewParagraph1:
      "Bunaai’s online storefront was built to reflect the elegance and vibrancy of its fashion line. I helped transform Figma designs into a fully responsive React and Shopify-integrated storefront. The goal was to deliver a frictionless shopping journey—from product discovery to checkout—while maintaining pixel-perfect design consistency and optimal performance across devices.",

    overviewChecks: [
      "Developed reusable React components based on Figma designs",
      "Integrated Shopify Buy SDK for real-time product updates",
      "Styled layout with SCSS and mobile-first responsiveness",
      "Optimized product gallery, filtering, and cart logic",
      "Maintained brand elegance with performance-focused code",
    ],

    testingResultParagraphs: [
      "Tested the website across major mobile and desktop viewports, with close attention to product navigation, image carousels, and real-time cart updates via the Shopify SDK.",
      "Performed cross-browser and device testing, validating dynamic behavior with test collections and responsive interactions. Debugged and optimized slow-loading assets before launch.",
    ],

    tags: [
      {
        name: "React, shopify",
        color: "blue-text-gradient",
      },
      {
        name: "CSS, SCSS",
        color: "green-text-gradient",
      },
      {
        name: "Figma-design",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Bunaai E-commerce | React + Shopify Store by Deep Kapadia",
      description:
        "Deep Kapadia helped build Bunaai’s online fashion store using React and Shopify SDK — transforming Figma designs into responsive, elegant layouts with seamless cart, gallery, and product filtering.",
      keywords:
        "Bunaai, Bunaai Fashion Store, Shopify Buy SDK, React E-commerce, Deep Kapadia Projects, SCSS Responsive Design, Jaipur Clothing Brand, Figma to Code",
    },

    image: bunaai,
    websiteLink: "https://www.bunaai.com/",
    isVideo: false,
  },
  // OpenMD
  {
    name: "OpenMD - openmd.com",
    description:
      "OpenMD is a comprehensive medical search engine that helps users find reliable health information by indexing billions of documents from trusted sources like government agencies, medical journals, and global health organizations.",
    slug: "openmd-medical-search",
    title: "OpenMD - openmd.com",
    category: "Healthcare / Search Engine",
    client: "OpenMD Team",
    date: "10 Jul 2025",
    location: "United States",
    designer: "-",
    gridImages1: [openMd, openMdMobile],
    gridImages2: [openMdIpad, openMdScreen1, openMdScreen2],

    overviewParagraph1:
      "I helped build and enhance OpenMD, a medical reference platform designed to provide quick and reliable access to health-related documents. The project focused on high-performance search, intuitive navigation, and intelligent categorization of medical content. It aggregates documents from institutions like NIH, WHO, and medical journals, and presents them in a clean, searchable interface.",

    overviewChecks: [
      "Engineered a high-speed search interface using React.js and smart indexing logic",
      "Integrated APIs to fetch and categorize millions of medical documents",
      "Built responsive layouts optimized for doctors, researchers, and patients",
      "Implemented advanced filtering, tag-based results, and document previews",
      "Optimized accessibility and SEO for health-related queries",
    ],

    testingResultParagraphs: [
      "Full-system QA covered real-world use cases for searching by disease, treatment, and organizations. Edge-case handling ensured the search engine remained robust across billions of data points.",
      "Accessibility checks were performed with screen readers and contrast validators. SEO testing ensured proper crawling and indexing by Google and medical aggregators.",
    ],

    tags: [
      {
        name: "React.js",
        color: "blue-text-gradient",
      },
      {
        name: "Search Engine",
        color: "green-text-gradient",
      },
      {
        name: "Healthcare",
        color: "pink-text-gradient",
      },
      {
        name: "API Integration",
        color: "orange-text-gradient",
      },
    ],

    // ✅ SEO data
    SEO: {
      title: "OpenMD | Medical Search Platform by Deep Kapadia",
      description:
        "Explore OpenMD – a healthcare-focused search platform developed by Deep Kapadia. Featuring React-based UI, document indexing, and API-powered results for doctors and patients alike.",
      keywords:
        "OpenMD, Medical Search Engine, Health Platform, React Healthcare UI, Deep Kapadia Projects, OpenMD Website, Search APIs, WHO NIH Data",
    },

    image: openMdIpad,
    websiteLink: "https://openmd.com/",
    isVideo: false,
  },
  // dumbgood
  {
    name: "dumbgood",
    description:
      "Dumb Good Elevate your style with our fashion-forward website, where trends meet timeless elegance for a personalized shopping experience.",
    slug: "dumbgood-e-commerce",
    title: "Dumb Good",
    category: "E-commerce",
    client: "Justin Deanda and Jonathan M",
    date: "06 Sep 2023",
    location: "Texas, United States",
    designer: "-",
    gridImages1: [dumbgood, dumbgoodMobile],
    gridImages2: [dumbgoodIpad, dumbgoodScreen1, dumbgoodScreen2],

    overviewParagraph1:
      "For Dumb Good, I developed a robust fashion e-commerce platform that blends aesthetics with performance. The site was structured in React.js with backend CRM integration to streamline inventory, user management, and order flows. Each product section and cart mechanism was optimized to reflect the brand’s fast-moving fashion ethos with speed and style.",

    overviewChecks: [
      "Built component-based layout in React.js from design spec",
      "Connected custom backend CRM for product & user data",
      "Integrated responsive cart and dynamic checkout logic",
      "Created filterable product collections with variant support",
      "Ensured pixel-perfect styling aligned with brand guidelines",
    ],

    testingResultParagraphs: [
      "End-to-end testing was done for the entire shopping flow including add-to-cart, login, and CRM-backed order placements. Focused QA rounds ensured seamless transitions between sections.",
      "Cross-browser testing and Lighthouse audits helped refine performance, loading speed, and user interactions, especially under mobile networks and slow connections.",
    ],

    tags: [
      {
        name: "React.js",
        color: "blue-text-gradient",
      },
      {
        name: "Backend (CRM)",
        color: "green-text-gradient",
      },
      {
        name: "Design Codes",
        color: "pink-text-gradient",
      },
      {
        name: "Cart & Checkout Integration",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Dumb Good | Fashion E-commerce by Deep Kapadia",
      description:
        "Explore the high-performance fashion e-commerce site built for Dumb Good by Deep Kapadia. From React.js components to CRM integration and responsive checkout, it blends speed and style with pixel-perfect design.",
      keywords:
        "Dumb Good, Fashion E-commerce, React Shopping Site, Deep Kapadia Projects, CRM Integration, Dumb Good Store, Cart Checkout Logic",
    },

    image: dumbgood,
    websiteLink: "https://dumbgood.com/",
    isVideo: false,
  },
  // vihatech
  {
    name: "VihaTech Website",
    description:
      "VihaTech Software Solutions supports project planning with a strong focus on technology, specializing in web development, e-commerce, UX, and community solutions.",
    slug: "vihatech-website",
    title: "VihaTech Website",
    category: "Web Development | IT Company",
    client: "VihaTech",
    date: "01 Oct 2023",
    location: "Indore, India",
    designer: "-",
    gridImages1: [vihatech, vihatechMobile],
    gridImages2: [vihatechIpad, vihatechScreen1, vihatechScreen2],

    overviewParagraph1:
      "I developed a clean, professional company portfolio site for VihaTech using a PHP CodeIgniter backend and responsive front-end stack. The goal was to highlight the agency’s tech services, project workflow, and domain expertise while maintaining smooth navigation and SEO-ready structure across devices.",

    overviewChecks: [
      "Created responsive layout with HTML, SCSS, and Bootstrap",
      "Structured backend using CodeIgniter for modular content management",
      "Implemented clean, tech-themed UI to match brand identity",
      "Built separate portfolio/project showcase sections",
      "Ensured cross-device accessibility and SEO readiness",
    ],

    testingResultParagraphs: [
      "Manual and browser-based QA testing was done across desktop and mobile devices to validate UI responsiveness and smooth transitions.",
      "Functional testing was performed for form handling, navigation, and dynamic routes. Optimizations ensured compatibility on all modern browsers.",
    ],

    tags: [
      {
        name: "HTML",
        color: "blue-text-gradient",
      },
      {
        name: "CSS, SCSS, Bootstrap",
        color: "green-text-gradient",
      },
      {
        name: "PHP CodeIgniter",
        color: "pink-text-gradient",
      },
      {
        name: "Portfolios",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "VihaTech Website | Company Portfolio by Deep Kapadia",
      description:
        "Discover how Deep Kapadia built a tech-focused portfolio site for VihaTech using CodeIgniter and Bootstrap. Clean layout, modular backend, and SEO-friendly structure to showcase services and projects.",
      keywords:
        "VihaTech Website, IT Portfolio Website, CodeIgniter Company Site, Bootstrap Layout, Deep Kapadia Projects, Responsive Tech Website, SEO-Ready Web Design",
    },

    image: vihatech,
    websiteLink: "https://staging.vihatech.co/home",
    isVideo: false,
  },
  // Aqari360
  {
    name: "Aqari360 Real-Estate",
    description:
      "The project, built with ReactJS and a PHP backend, SQL database, features VR tour and 360-degree image view functionality, utilizing advanced web programming solutions.",
    slug: "aqari360-real-estate",
    title: "Aqari360 Real-Estate",
    category: "Real-Estate | Property Finder",
    client: "Sir. Abdullah Alburadi",
    date: "02 Nov 2023",
    location: "Riyadh, Saudi Arabia",
    designer: "-",
    gridImages1: [aqari360, aqari360Mobile],
    gridImages2: [aqari360Ipad, aqari360Screen1, aqari360Screen2],

    overviewParagraph1:
      "Developed a full-featured real estate platform with 360-degree property viewing, VR tour support, and a robust search engine for listings. Using ReactJS and a PHP CodeIgniter backend, I focused on creating an intuitive, high-performance interface for buyers, sellers, and agents to explore properties seamlessly across devices.",

    overviewChecks: [
      "Built interactive property listings with filters and location search",
      "Integrated 360° image viewer and VR tour features",
      "Used React.js for dynamic UI and fast rendering",
      "Structured backend in PHP CodeIgniter with SQL DB integration",
      "Ensured multi-device support and fast load times",
    ],

    testingResultParagraphs: [
      "Performed functional and UX testing for listing filters, search features, and VR interactions. Verified performance under multiple listing loads.",
      "Cross-browser and mobile testing were conducted to ensure the 360-view worked without lag. Backend APIs were tested for SQL integrity and scalability.",
    ],

    tags: [
      {
        name: "React JS",
        color: "pink-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "blue-text-gradient",
      },
      {
        name: "PHP CodeIgniter, SQL",
        color: "green-text-gradient",
      },
      {
        name: "VR-Tour & 360Viewer",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Aqari360 | Real Estate VR Platform by Deep Kapadia",
      description:
        "Explore Aqari360, a real-estate platform built by Deep Kapadia using React and PHP CodeIgniter, featuring 360° property views, VR tours, and a dynamic property search interface for Saudi buyers and agents.",
      keywords:
        "Aqari360, Real Estate Platform, VR Property Tour, React Real Estate UI, Deep Kapadia Projects, 360 Viewer, PHP CodeIgniter, Property Listing Website",
    },

    image: aqari360,
    websiteLink: "https://aqari360-ta.com",
    isVideo: false,
  },
  // diffr-event
  {
    name: "Diffr - Event Screen Figma to HTML",
    description:
      "Diffr platform connects job seekers with top employers, providing tailored job recommendations based on skills, experience, and career aspirations.",
    slug: "diffr-event",
    title: "Diffr - Event Screen Figma to HTML",
    category: "Freelancers Site",
    client: "Pulkit Jain",
    date: "12 Dec 2023",
    location: "Indore, India",
    designer: "-",
    gridImages1: [diffrEvent, diffrEventMobile],
    gridImages2: [diffrEventIpad],

    overviewParagraph1:
      "This project involved converting a clean and functional event screen UI from Figma into pixel-perfect HTML and CSS. With a focus on responsive layout and mobile-friendly interactions, I ensured visual consistency with the original design while optimizing it for performance and Laravel backend integration.",

    overviewChecks: [
      "Converted Figma design into pixel-perfect HTML/CSS",
      "Used semantic HTML5 and modular SCSS structure",
      "Ensured full mobile responsiveness across screen sizes",
      "Integrated code with Laravel views and blade structure",
      "Tested for browser compatibility and load performance",
    ],

    testingResultParagraphs: [
      "Tested layout and styles in Chrome, Firefox, Safari, and Edge to ensure visual consistency. Adjusted spacing and breakpoints based on responsive behavior testing.",
      "Ensured all clickable elements, spacing, and typography matched the Figma reference precisely. Final screens were reviewed with client for visual approval before integration.",
    ],

    tags: [
      {
        name: "FIGMA to HTML",
        color: "blue-text-gradient",
      },
      {
        name: "Laravel",
        color: "green-text-gradient",
      },
      {
        name: "Core CSS",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Diffr Event Screen | Figma to HTML Conversion by Deep Kapadia",
      description:
        "High-fidelity conversion of Diffr’s event screen from Figma to HTML with semantic code, SCSS structure, Laravel Blade integration, and mobile-first responsiveness by Deep Kapadia.",
      keywords:
        "Figma to HTML, Event Screen Conversion, Diffr Project, Deep Kapadia HTML Work, Laravel Blade Views, Freelance Project, HTML CSS SCSS Conversion",
    },

    image: diffrEvent,
    websiteLink: "https://diffr.co.in/event-photography",
    isVideo: false,
  },
  // 3333 MAGICKEY
  {
    name: "3333 MAGICKEYS",
    description:
      "Empowering authors to earn more by transforming their books into communities, unfolding a new and enhanced reading experience through decentralized storytelling.",
    slug: "3333-magic-keys",
    title: "3333 MAGICKEYS",
    category: "DeBook - 3333 Magic Keys",
    client: "Ernest Vinas",
    date: "27 Dec 2023",
    location: "Barcelona, Spain",
    designer: "-",
    gridImages1: [magicKey, magicKeyMobile],
    gridImages2: [magicKeyIpad],

    overviewParagraph1:
      "3333 MAGICKEYS is a decentralized book (DeBook) platform built on Next.js, designed to revolutionize how authors engage with readers. The project allows authors to tokenize access to exclusive book content, build community interactions, and monetize fan engagement using NFT-based key distribution. Rich animations and immersive user experience drive higher reader retention and discovery.",

    overviewChecks: [
      "Developed using Next.js for performance and scalability",
      "Web3-driven token system for gated reading access",
      "Interactive CSS animations and transitions for modern appeal",
      "Custom dynamic content rendering for each book/key",
      "Optimized mobile-friendly interface with smooth UX",
    ],

    testingResultParagraphs: [
      "We tested wallet integrations and key validation across devices and browsers to ensure consistent gated access experiences.",
      "Performance audits were conducted using Lighthouse and manual stress tests, resulting in enhanced responsiveness and minimal load times.",
    ],

    tags: [
      {
        name: "Next JS",
        color: "blue-text-gradient",
      },
      {
        name: "JavaScript",
        color: "green-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "pink-text-gradient",
      },
      {
        name: "CSS Animations",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "3333 MAGICKEYS | Decentralized Reading Platform by Deep Kapadia",
      description:
        "Explore 3333 MAGICKEYS, a Web3-powered decentralized storytelling platform built by Deep Kapadia with Next.js. Token-gated access, immersive UX, and community-driven content delivery.",
      keywords:
        "3333 MAGICKEYS, DeBook, Web3 Reading App, Tokenized Books, NFT Gated Content, Deep Kapadia, Next.js Platform, Decentralized Storytelling",
    },

    image: magicKey,
    websiteLink: "https://debook-kappa.vercel.app/",
    isVideo: false,
  },
  // M-Jawlah360
  {
    name: "Jawlah360 Real-Estate",
    description:
      "Jawlah360 - Media Preview provides a seamless platform for high-resolution viewing of images, videos, and 360-degree content with smooth navigation.",
    slug: "jawlah360-real-estate",
    title: "Jawlah360 Real-Estate",
    category: "Real-Estate, VR Tour & 360Viewer",
    client: "Sir. Abdullah Alburadi",
    date: "02 Nov 2023",
    location: "Riyadh, Saudi Arabia",
    designer: "-",
    gridImages1: [mjawlah360, mjawlah360],
    gridImages2: [mjawlah360, mjawlah360, mjawlah360],

    overviewParagraph1:
      "Jawlah360 is a high-performance, real-estate-focused media platform that delivers an immersive 360-degree virtual experience. We engineered a dynamic React-based front end with rich media controls and seamless VR-tour support, all backed by a scalable CodeIgniter and SQL-powered backend. This project focused on performance, responsiveness, and enhancing real-estate presentation quality.",

    overviewChecks: [
      "Built interactive VR and 360° viewing modules for property walkthroughs",
      "Responsive React.js interface with dynamic content rendering",
      "Backend powered by PHP CodeIgniter with SQL-based data management",
      "Optimized user experience for mobile and desktop browsing",
      "Implemented fast-loading image/video viewer with minimal latency",
    ],

    testingResultParagraphs: [
      "Each module was rigorously tested across platforms, ensuring full support for high-resolution panoramas, smooth transitions, and interactive controls across devices.",
      "Validated real-time performance of media viewers, measured API responsiveness, and fixed compatibility issues for both legacy and modern browsers.",
    ],

    tags: [
      {
        name: "React JS",
        color: "pink-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "blue-text-gradient",
      },
      {
        name: "PHP CodeIgniter, SQL",
        color: "green-text-gradient",
      },
      {
        name: "VR-Tour & 360Viewer",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Jawlah360 | Immersive VR Property Viewer by Deep Kapadia",
      description:
        "Jawlah360 is a dynamic React + CodeIgniter platform developed by Deep Kapadia to deliver high-resolution virtual property tours with smooth transitions and responsive 360-degree navigation.",
      keywords:
        "Jawlah360, Real Estate VR Tour, 360 Viewer, Deep Kapadia Real Estate Project, PHP CodeIgniter, React Real Estate UI, Panoramic Property Viewer",
    },

    image: mjawlah360,
    websiteLink: "https://m.jawlah360.com/PRO32545",
    isVideo: false,
  },
  // Business Ignites
  {
    name: "Business Ignites",
    description:
      "Business Ignites is a business and marketing implementation firm helping organizations scale, streamline, and transform into profitable turnkey operations.",
    slug: "business-ignites",
    title: "Business Ignites",
    category: "Strategy & Consulting",
    client: "Victor Kon",
    date: "25 May 2021",
    location: "Melbourne, Australia",
    designer: "-",
    gridImages1: [businessIgnite, businessIgniteMobile],
    gridImages2: [
      businessIgniteIpad,
      businessIgniteScreen1,
      businessIgniteScreen2,
    ],

    overviewParagraph1:
      "We designed and developed a dynamic business consulting dashboard that empowers users to manage workflows, visualize KPIs, and automate marketing insights. The interface integrates CRM tools, analytics, and brand elements into a seamless, user-centric platform tailored for scaling operations and service delivery.",

    overviewChecks: [
      "Tailored CRM integration for client tracking",
      "Custom dashboard UI for business KPIs and automation",
      "Branded UI/UX aligned with consulting objectives",
      "Mobile-optimized responsive interface",
      "Secure user roles and data privacy measures",
    ],

    testingResultParagraphs: [
      "Thorough QA included performance optimization, usability testing across admin and client-facing modules, and browser/device compatibility checks.",
      "All key CRM workflows were validated to ensure seamless client onboarding, data integrity, and intuitive interaction flows.",
    ],

    tags: [
      {
        name: "React.js",
        color: "blue-text-gradient",
      },
      {
        name: "Backend (CRM)",
        color: "green-text-gradient",
      },
      {
        name: "Design Codes",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Business Ignites | Consulting CRM Dashboard by Deep Kapadia",
      description:
        "Custom-built business consulting dashboard by Deep Kapadia, combining CRM tools, KPIs, and automation with responsive design to help consulting firms scale operations.",
      keywords:
        "Business Ignites, CRM Dashboard, Business Consulting Tools, Deep Kapadia, Workflow Automation, React CRM UI, KPI Visualization Platform",
    },

    image: businessIgnite,
    websiteLink: "https://businessignites.com/",
    isVideo: false,
  },
  // News Bulb
  {
    name: "News Bulb Email",
    description:
      "NewsBulb is India’s first vernacular audio news app—offering users the freedom to stay updated with news while traveling, walking, or cooking, through bite-sized audio content in regional languages.",
    slug: "news-bulb",
    title: "News Bulb",
    category: "News App",
    client: "Manan Maheshwari",
    date: "25 Jun 2021",
    location: "Melbourne, Australia",
    designer: "-",
    gridImages1: [newsBulb, newsBulbMobile],
    gridImages2: [],

    overviewParagraph1:
      "Developed and optimized key modules for NewsBulb’s backend email notification system, enhancing user communication for updates, subscriptions, and personalized alerts. The system integrates mail templates with responsive HTML, automated delivery logic, and improved deliverability across platforms.",

    overviewChecks: [
      "Custom email templates matching brand tone",
      "Mailer.js implementation for automated dispatch",
      "Tested HTML/CSS for cross-client compatibility",
      "Responsive design for mobile & desktop inboxes",
      "Seamless integration with NewsBulb's backend logic",
    ],

    testingResultParagraphs: [
      "The email system was tested for layout responsiveness, inbox rendering across major clients (Gmail, Outlook, Yahoo), and spam score optimization to ensure high deliverability.",
      "Bug fixes and tweaks were made post-testing to optimize load time, prevent rendering issues, and ensure alignment with the app’s overall UX flow.",
    ],

    tags: [
      {
        name: "Email Structure",
        color: "blue-text-gradient",
      },
      {
        name: "Mailer.js",
        color: "green-text-gradient",
      },
      {
        name: "CSS & HTML",
        color: "pink-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "News Bulb | Audio News Email System by Deep Kapadia",
      description:
        "Backend email system for News Bulb built by Deep Kapadia, enhancing communication via Mailer.js, responsive templates, and cross-client compatibility for India’s top audio news app.",
      keywords:
        "News Bulb, Audio News App, Email Notification System, Mailer.js Integration, Deep Kapadia, Vernacular News Delivery, HTML Email Templates",
    },

    image: newsBulb,
    websiteLink: "https://newsbulb.in/",
    isVideo: false,
  },
  // Siddhivinayak Group
  {
    name: "Siddhivinayak Group",
    description:
      "Siddhivinayak Group, established in 1998, has grown into a leading construction and real estate development company in Gujarat, delivering a diverse portfolio of residential and commercial projects across Surat and beyond.",
    slug: "siddhivinayak-group",
    title: "Siddhivinayak Group",
    category: "Contractor & Builder",
    client: "Suhash Jani",
    date: "16 Aug 2022",
    location: "Surat, India",
    designer: "-",
    gridImages1: [siddhivinayakGroup, siddhivinayakGroupMobile],
    gridImages2: [
      siddhivinayakGroupIpad,
      siddhivinayakGroupScreen1,
      siddhivinayakGroupScreen2,
    ],

    overviewParagraph1:
      "Developed a corporate website to showcase Siddhivinayak Group’s construction legacy, featuring project listings, milestone highlights, and dynamic reveal animations for a smooth, immersive user experience. The platform focuses on performance, clarity, and responsive navigation to build trust with potential clients and investors.",

    overviewChecks: [
      "Clean, structured UI with brand-consistent design",
      "Built with PHP and CodeIgniter framework",
      "Bootstrap-based responsive layout",
      "Scroll-triggered reveal animations for content sections",
      "Optimized project galleries and call-to-actions",
    ],

    testingResultParagraphs: [
      "Thorough testing across modern browsers and devices was conducted to ensure all animations and responsive behaviors rendered seamlessly.",
      "Performance optimization tasks focused on reducing image load times, script execution, and layout shifts for a professional user journey.",
    ],

    tags: [
      {
        name: "PHP",
        color: "blue-text-gradient",
      },
      {
        name: "CodeIgniter",
        color: "green-text-gradient",
      },
      {
        name: "CSS, SCSS, Bootstrap",
        color: "pink-text-gradient",
      },
      {
        name: "Reveal Animations",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Siddhivinayak Group | Construction & Real Estate in Gujarat",
      description:
        "Corporate site for Siddhivinayak Group, built by Deep Kapadia using PHP & CodeIgniter to showcase real estate projects, achievements, and a responsive portfolio.",
      keywords:
        "Siddhivinayak Group, Surat Builder, Construction Company India, CodeIgniter Website, Real Estate Showcase, Deep Kapadia Developer",
    },

    image: siddhivinayakGroup,
    websiteLink: "https://siddhivinayakgroup.in/",
    isVideo: false,
  },
  //Tasheel.sa
  {
    name: "Tasheel - Scholarship",
    description:
      "Tasheel is an officially licensed Scholarship Facilitation Office in Saudi Arabia (CR No. 1131333836), providing end-to-end support to students seeking admission into global universities.",
    slug: "tasheel-scholarship",
    title: "Tasheel - Scholarship",
    category: "Education",
    client: "Sir. Abdullah Alburadi",
    date: "16 Nov 2024",
    location: "Riyadh, Saudi Arabia",
    designer: "-",
    gridImages1: [tasheel, tasheelMobile],
    gridImages2: [tasheelIpad, tasheelScreen1, tasheelScreen2],

    overviewParagraph1:
      "We developed a comprehensive scholarship management platform for Tasheel, enabling students to browse, apply, and track scholarship programs offered by international universities. The dashboard was crafted with usability in mind—featuring institutional data panels, student application workflows, and multilingual support for accessibility across audiences.",

    overviewChecks: [
      "Custom dashboard for scholarship and student data",
      "University management & program categorization",
      "Multi-role login system (Admin, Students, Advisors)",
      "Developed with Next.js frontend and PHP backend",
      "Responsive, RTL-compatible design for Arabic audience",
    ],

    testingResultParagraphs: [
      "All core features, from application tracking to admin controls, underwent rigorous testing for functionality, performance, and security.",
      "Cross-device and cross-browser compatibility was verified to ensure smooth interaction for both mobile and desktop users.",
    ],

    tags: [
      {
        name: "Next JS",
        color: "pink-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "blue-text-gradient",
      },
      {
        name: "PHP CodeIgniter, SQL",
        color: "green-text-gradient",
      },
      {
        name: "Universities-Management",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Tasheel Scholarship | Student Dashboard & Admissions Portal",
      description:
        "Scholarship platform built with Next.js and PHP for Tasheel.sa, enabling global university access with admin workflows, RTL support, and student tracking.",
      keywords:
        "Tasheel Scholarship, Education Platform, Next.js, PHP CodeIgniter, Student Dashboard, Deep Kapadia, University Admission Portal",
    },

    image: tasheel,
    websiteLink: "https://tasheel.sa/",
    isVideo: false,
  },
  // Jawlah360
  {
    name: "Jawlah360 Real-Estate",
    description:
      "Jawlah360 is a cutting-edge real estate platform that integrates virtual reality and 360-degree viewing technology, enhancing property discovery and remote exploration for clients and agents alike.",
    slug: "jawlah360-real-estate",
    title: "Jawlah360 - Real Estate",
    category: "Real Estate",
    client: "Sir. Abdullah Alburadi",
    date: "16 Dec 2024",
    location: "Riyadh, Saudi Arabia",
    designer: "-",
    gridImages1: [Jawlah360, Jawlah360],
    gridImages2: [Jawlah360, Jawlah360, Jawlah360],

    overviewParagraph1:
      "Jawlah360 delivers immersive property visualization through VR tours and 360-degree image viewers. Built with ReactJS and powered by a PHP (CodeIgniter) backend, the platform enables seamless listing management, interactive virtual walkthroughs, and optimized performance across all devices. The interface is tailored to handle multilingual real estate content efficiently.",

    overviewChecks: [
      "Built with ReactJS frontend and PHP (CodeIgniter) backend",
      "360-degree image integration for enhanced property views",
      "VR-tour functionality for immersive exploration",
      "Admin dashboard for listing, media, and lead management",
      "Optimized for performance, accessibility, and mobile UX",
    ],

    testingResultParagraphs: [
      "The platform was tested for responsive behavior, usability, and visual fidelity across various devices and browsers.",
      "Advanced testing included VR media compatibility, dynamic content loading, and optimized rendering for 360-degree assets.",
    ],

    tags: [
      {
        name: "React JS",
        color: "pink-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "blue-text-gradient",
      },
      {
        name: "PHP CodeIgniter, SQL",
        color: "green-text-gradient",
      },
      {
        name: "VR-Tour & 360Viewer",
        color: "orange-text-gradient",
      },
    ],

    // ✅ SEO data
    SEO: {
      title: "Jawlah360 | Virtual Real Estate Platform with VR & 360 Tours",
      description:
        "Immersive real estate platform powered by ReactJS and CodeIgniter, featuring 360° tours, VR walkthroughs, and multilingual listing tools developed by Deep Kapadia.",
      keywords:
        "Jawlah360, VR Property Tours, Real Estate Platform, 360 Viewer, ReactJS Real Estate Site, Deep Kapadia, Virtual Tour Website",
    },

    image: Jawlah360,
    websiteLink: "https://jawlah360-ta.com",
    isVideo: false,
  },
  // Souq Alfajr
  {
    name: "Souq Alfajr",
    description:
      "Souq Alfajr is a fast and reliable e-commerce delivery platform offering 24-hour fulfillment across local regions. Designed for efficiency and convenience, it ensures seamless order-to-door service with optimized logistics and tracking.",
    slug: "souq-alfajr",
    title: "Souq Alfajr",
    category: "E-commerce",
    client: "Sir. Abdullah Alburadi",
    date: "16 Dec 2024",
    location: "Riyadh, Saudi Arabia",
    designer: "-",
    gridImages1: [souqalfajr, souqalfajrMobile],
    gridImages2: [souqalfajrIpad, souqalfajrScreen1, souqalfajrScreen2],

    overviewParagraph1:
      "Souq Alfajr was developed to streamline express deliveries through a robust ReactJS frontend and SQL-backed admin panel. With focus on UX, real-time status updates, and backend logistics control, this e-commerce solution handles both frontend shopping flow and backend operational needs. From product display to last-mile delivery coordination, the platform is optimized for speed, scalability, and cross-device usability.",

    overviewChecks: [
      "ReactJS frontend with modern UI/UX for online ordering",
      "Admin dashboard to manage products, orders, and delivery flow",
      "Integrated 24-hour delivery logic and real-time tracking updates",
      "Secure backend architecture using SQL and custom panel",
      "Performance-tuned SCSS-based styles for fast-loading UI",
    ],

    testingResultParagraphs: [
      "Thorough testing was done across major browsers and devices to ensure a seamless e-commerce experience, even under high order volume.",
      "Edge cases like overlapping orders, delivery time conflicts, and cart handling were validated through functional and usability tests.",
    ],

    tags: [
      {
        name: "React JS",
        color: "pink-text-gradient",
      },
      {
        name: "HTML, CSS, SCSS",
        color: "blue-text-gradient",
      },
      {
        name: "SQL, Backend Panel",
        color: "green-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Souq Alfajr | Fast E-commerce & 24-Hour Delivery Platform",
      description:
        "Souq Alfajr is a robust ReactJS-based e-commerce platform developed by Deep Kapadia, offering real-time order tracking, admin control, and optimized delivery services.",
      keywords:
        "Souq Alfajr, ReactJS E-commerce, 24-Hour Delivery Platform, Fast Checkout UI, Deep Kapadia, Order Tracking System",
    },

    image: souqalfajr,
    websiteLink: "https://souqalfajr-t.com/",
    isVideo: false,
  },
  // Najeeb
  {
    name: "Najeeb.sa E-learning",
    description:
      "Najeeb is a premium online learning platform tailored to provide high-quality academic content in a structured, accessible, and engaging format for students and educators alike. It simulates the private school environment in a digital-first experience.",

    slug: "najeeb",
    title: "Najeeb",
    category: "E-learning",
    client: "Sir. Abdullah Alburadi",
    date: "16 Dec 2024",
    location: "Riyadh, Saudi Arabia",
    designer: "-",

    gridImages1: [najeeb, najeebMobile],
    gridImages2: [najeebIpad, najeebScreen1, najeebScreen2],

    overviewParagraph1:
      "Najeeb’s platform was developed using PHP CodeIgniter with a fully customized SQL backend, providing role-based access for students, educators, and administrators. Features include structured class management, performance tracking, attendance monitoring, and secure content delivery—all integrated within a responsive, modern UI to ensure learning continuity across devices.",

    overviewChecks: [
      "Role-based access for students, teachers, and admins",
      "Interactive course modules with media support",
      "Dynamic attendance & assignment tracking",
      "Mobile-first responsive interface",
      "Secure backend panel for course/content management",
    ],

    testingResultParagraphs: [
      "We conducted multi-user role testing to ensure smooth navigation, proper access control, and error-free data flow across the platform.",
      "Thorough cross-device testing was done to validate responsiveness and functionality on smartphones, tablets, and desktops.",
    ],

    tags: [
      {
        name: "PHP CodeIgniter",
        color: "pink-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "blue-text-gradient",
      },
      {
        name: "SQL, Backend Panel",
        color: "green-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Najeeb.sa | Premium E-learning Portal with Role-Based Access",
      description:
        "Najeeb is a PHP CodeIgniter-based online learning portal developed by Deep Kapadia, offering secure multi-role access, performance tracking, and mobile-first UI.",
      keywords:
        "Najeeb E-learning, PHP Education Platform, Role-Based Access LMS, Online Learning Portal, Deep Kapadia, School Management System",
    },

    image: najeeb,
    websiteLink: "https://najeeb.sa",
    isVideo: false,
  },
  // Adminty Admin Pane
  {
    name: "Adminty Admin Panel",
    description:
      "Adminty is a comprehensive admin dashboard solution designed for travel platforms. It facilitates flight, hotel, and rental bookings while offering personalized recommendations for popular destinations through an intuitive backend system.",

    slug: "adminty",
    title: "Adminty",
    category: "Admin Panel",
    client: "Robert Smith",
    date: "14 Feb 2019",
    location: "California, USA",
    designer: "-",

    gridImages1: [adminty, admintyMobile],
    gridImages2: [admintyIpad, admintyScreen1, admintyScreen2],

    overviewParagraph1:
      "Adminty was developed to serve as the core administrative interface for a multi-service travel portal. Built using HTML, SCSS, and Bootstrap, it includes features like interactive DataTables, real-time chart visualization, and responsive UI components. Emphasis was placed on data accessibility, user experience, and consistent performance across devices.",

    overviewChecks: [
      "Custom Bootstrap UI with dark/light theme support",
      "Integrated real-time charts and analytics",
      "Modular, scalable architecture for future feature expansion",
      "DataTables for advanced search, filter, and pagination",
      "Fully responsive layout optimized for tablets and desktops",
    ],

    testingResultParagraphs: [
      "Extensive browser compatibility testing ensured consistent rendering across all major browsers.",
      "Data input fields and dynamic components were tested with mock datasets for speed, error handling, and UI integrity.",
    ],

    tags: [
      {
        name: "HTML",
        color: "blue-text-gradient",
      },
      {
        name: "Graphs",
        color: "green-text-gradient",
      },
      {
        name: "CSS, SCSS, Bootstrap",
        color: "pink-text-gradient",
      },
      {
        name: "DataTables, JQuery",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Adminty | Travel Admin Dashboard with Real-Time Charts",
      description:
        "Adminty is a Bootstrap-based travel admin panel developed by Deep Kapadia, featuring DataTables, responsive charts, and dynamic booking management for flights, hotels, and rentals.",
      keywords:
        "Adminty Dashboard, Admin Panel, Bootstrap UI, Real-Time Charts, DataTables, Travel Admin Backend, Deep Kapadia",
    },

    image: adminty,
    websiteLink: "https://demo.dashboardpack.com/adminty-html/index.html",
    isVideo: false,
  },
  // Lucid Admin Panel
  {
    name: "Lucid Admin Panel",
    description:
      "Lucid is an all-in-one admin dashboard designed for travel management platforms. It enables efficient booking of flights, hotels, and car rentals while delivering personalized destination suggestions based on user behavior and analytics.",

    slug: "lucid",
    title: "Lucid",
    category: "Admin Panel",
    client: "Robert Smith",
    date: "14 Apr 2019",
    location: "California, USA",
    designer: "-",

    gridImages1: [lucid, lucidMobile],
    gridImages2: [lucidIpad, lucidScreen1, lucidScreen2],

    overviewParagraph1:
      "Lucid Admin Panel was built with a strong emphasis on data visibility, usability, and scalable design architecture. The interface supports high-density data rendering through DataTables, chart visualizations, and real-time updates using jQuery. It leverages Bootstrap and SCSS for responsiveness and theme customization.",

    overviewChecks: [
      "Modular Bootstrap-based component system",
      "Real-time chart visualizations using Chart.js",
      "DataTables integration with advanced filters and export",
      "Responsive SCSS design system",
      "Cross-browser, cross-device compatibility",
    ],

    testingResultParagraphs: [
      "The platform underwent rigorous testing for cross-browser functionality and responsiveness across breakpoints.",
      "We also ensured smooth integration of dynamic charts, dropdowns, and modals under heavy data loads, validating performance benchmarks on both desktop and tablet devices.",
    ],

    tags: [
      {
        name: "HTML",
        color: "blue-text-gradient",
      },
      {
        name: "Graphs",
        color: "green-text-gradient",
      },
      {
        name: "CSS, SCSS, Bootstrap",
        color: "pink-text-gradient",
      },
      {
        name: "DataTables, JQuery",
        color: "orange-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "Lucid | Admin Panel with DataTables & Real-Time Analytics",
      description:
        "Lucid is a modular Bootstrap admin dashboard created by Deep Kapadia, optimized for travel management with dynamic charts, advanced DataTables, and responsive SCSS styling.",
      keywords:
        "Lucid Admin Panel, Bootstrap Dashboard, Chart.js, DataTables, Travel Admin UI, Responsive Admin Template, Deep Kapadia",
    },

    image: lucid,
    websiteLink:
      "https://www.wrraptheme.com/templates/lucid/html/dark/index.html",
    isVideo: false,
  },
  // Pathshala
  {
    name: "PathShala - Backend",
    description:
      "PathShala is a charity organization that offers student scholarships and manages academic and donor data through a custom-built admin dashboard. It also supports e-commerce operations to aid fundraising and outreach initiatives.",

    slug: "pathshala",
    title: "PathShala",
    category: "Admin Panel",
    client: "Robert Smith",
    date: "24 June 2022",
    location: "Indore, India",
    designer: "-",

    gridImages1: [songadhpathshala, songadhpathshalaMobile],
    gridImages2: [
      songadhpathshalaIpad,
      songadhpathshalaScreen1,
      songadhpathshalaScreen2,
    ],

    overviewParagraph1:
      "The PathShala admin panel was developed to centralize scholarship applications, student records, donor data, and product sales into a streamlined backend system. Built using PHP CodeIgniter and SQL, it features dynamic tables, permission-based access control, and a structured UI to ensure ease of use and data integrity across modules.",

    overviewChecks: [
      "Role-based admin panel with secure authentication",
      "Student and donor data management",
      "E-commerce product listings and order tracking",
      "Reports and export functionalities",
      "Custom design system using SCSS and Bootstrap",
    ],

    testingResultParagraphs: [
      "Thorough testing was conducted to validate form handling, database relationships, and permission logic across admin roles. Accessibility and responsiveness were verified across screen sizes.",
      "The system was also load-tested with simulated concurrent users to ensure performance and data integrity, especially in student search and scholarship assignment modules.",
    ],

    tags: [
      {
        name: "PHP CodeIgniter",
        color: "pink-text-gradient",
      },
      {
        name: "HTML, CSS, JS",
        color: "blue-text-gradient",
      },
      {
        name: "SQL, Backend Panel",
        color: "green-text-gradient",
      },
    ],
    // ✅ SEO data
    SEO: {
      title: "PathShala | Charity & Scholarship Admin Panel",
      description:
        "PathShala is a PHP CodeIgniter-based admin system built by Deep Kapadia for managing student scholarships, donor data, and fundraising e-commerce with role-based access.",
      keywords:
        "PathShala Admin, Scholarship Backend, Charity Dashboard, PHP CodeIgniter, Admin Panel UI, Student Donor Management, Deep Kapadia",
    },

    image: songadhpathshala,
    websiteLink: "https://songadhpathshala.com/",
    isVideo: false,
  },
];

export {projectsHomeData, projects};
